import { render, staticRenderFns } from "./CreateDemoUserDialog.vue?vue&type=template&id=19b29217&"
import script from "./CreateDemoUserDialog.vue?vue&type=script&lang=js&"
export * from "./CreateDemoUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QForm,QCardSection,QSpace,QBtn,QInput,QSelect,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QForm,QCardSection,QSpace,QBtn,QInput,QSelect,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
